import React from 'react'

import { Helmet } from 'react-helmet'

import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Order Submission</title>
        <meta property="og:title" content="Order Submission" />
      </Helmet>
      <iframe
        src="https://c4belts.retool.com/embedded/public/fb88df07-2c14-41a9-9217-155bbeba69ee"
        allowFullScreen
        className="home-iframe"
      ></iframe>
    </div>
  )
}

export default Home
